var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 1126,
    viewBox: "0 0 740 1126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 720,
    height: 1106,
    fill: "#4D31FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2374_65786)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2374_65786)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 720,
    height: 1106,
    fill: "url(#paint0_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2374_65786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.699 954.192V687.075C405.699 670.59 419.063 657.226 435.549 657.226H636.077C652.563 657.226 665.927 670.59 665.927 687.075V954.192H405.699Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.251 954.192V887.604C632.251 871.118 645.615 857.754 662.101 857.754H686.593C703.078 857.754 716.442 871.118 716.442 887.604V954.192H632.251Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.182 817.95V827.9C554.182 844.385 567.547 857.749 584.032 857.749H686.593C703.078 857.749 716.442 844.385 716.442 827.9V817.95H554.182Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.906 657.222L440.906 665.641C440.906 682.127 454.27 695.491 470.755 695.491L554.181 695.491L554.181 657.222L440.906 657.222Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.6108,
    y: 739.886,
    width: 296.966,
    height: 260.228,
    rx: 29.8497,
    transform: "rotate(-90 -82.6108 739.886)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.6108,
    y: 778.152,
    width: 241.859,
    height: 523.517,
    rx: 29.8497,
    transform: "rotate(-90 -82.6108 778.152)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 778.152C-69.2467 778.152 -82.6108 764.788 -82.6108 748.302L-82.6108 566.143C-82.6108 549.657 -69.2467 536.293 -52.7612 536.293H375.849C392.335 536.293 405.699 549.657 405.699 566.143V778.152H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 778.152C-69.2467 778.152 -82.6108 764.788 -82.6108 748.302L-82.6108 650.334C-82.6108 633.849 -69.2467 620.484 -52.7612 620.484H375.849C392.335 620.484 405.699 633.849 405.699 650.334V778.152H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.4765 778.152C-74.0441 778.152 -82.6108 769.585 -82.6108 759.017C-82.6108 748.45 -74.0441 739.883 -63.4764 739.883H228.897C245.383 739.883 258.747 753.247 258.747 769.733V778.152H-63.4765Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 778.152C-69.2467 778.152 -82.6108 791.516 -82.6108 808.001V870.762C-82.6108 887.248 -69.2467 900.612 -52.7612 900.612H262.574C279.059 900.612 292.423 887.248 292.423 870.762V778.152H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.425 778.152V788.101C292.425 804.587 305.789 817.951 322.274 817.951H405.7V778.152H292.425Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 900.613V909.033C143.941 925.518 157.305 938.882 173.791 938.882H258.748V900.613H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.617 620.484V627.373C177.617 643.858 190.981 657.222 207.467 657.222H292.424V620.484H177.617Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.974 938.881L524.331 938.881C540.817 938.881 554.181 925.517 554.181 909.031L554.181 817.952L518.974 817.952L518.974 938.881Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6634,
    y: 778.152,
    width: 298.497,
    height: 261.759,
    rx: 29.8497,
    transform: "rotate(-90 30.6634 778.152)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 863.87,
    width: 384.219,
    height: 73.4761,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 863.87)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 961.847,
    width: 99.4988,
    height: 150.014,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 961.847)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 961.847,
    width: 61.2301,
    height: 410.241,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 961.847)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 938.881L143.941 595.227C143.941 578.742 157.305 565.378 173.791 565.378H337.581C354.067 565.378 367.431 578.742 367.431 595.227V938.881H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 938.881V587.573C554.183 571.088 540.819 557.724 524.333 557.724H397.281C380.795 557.724 367.431 571.088 367.431 587.573V938.881H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.333 997.051C540.819 997.051 554.183 983.687 554.183 967.201V817.953H397.281C380.795 817.953 367.431 831.317 367.431 847.803V967.201C367.431 983.687 380.795 997.051 397.281 997.051H524.333Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.765376,
    y: -0.765376,
    width: 122.46,
    height: 205.121,
    rx: 29.8497,
    transform: "matrix(0 -1 -1 0 724.862 817.185)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.203,
    y: 1039.91,
    width: 261.759,
    height: 411.772,
    rx: 29.8497,
    transform: "rotate(-90 107.203 1039.91)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.747,
    y: 1039.91,
    width: 382.688,
    height: 407.18,
    rx: 29.8497,
    transform: "rotate(-90 258.747 1039.91)",
    stroke: "#363746",
    strokeWidth: 1.53075
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2374_65786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.699 923.403V1190.52C405.699 1207 419.063 1220.37 435.549 1220.37H636.077C652.563 1220.37 665.927 1207 665.927 1190.52V923.403H405.699Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.251 923.403V989.99C632.251 1006.48 645.615 1019.84 662.101 1019.84H686.593C703.078 1019.84 716.442 1006.48 716.442 989.991V923.403H632.251Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.182 1059.64V1049.69C554.182 1033.21 567.547 1019.84 584.032 1019.84H686.593C703.078 1019.84 716.442 1033.21 716.442 1049.69V1059.64H554.182Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 241.859,
    height: 523.517,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -83.3762 1098.68)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 1099.44C-69.2467 1099.44 -82.6108 1112.81 -82.6108 1129.29L-82.6108 1311.45C-82.6108 1327.94 -69.2467 1341.3 -52.7612 1341.3H375.849C392.335 1341.3 405.699 1327.94 405.699 1311.45V1099.44H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 1099.44C-69.2467 1099.44 -82.6108 1112.81 -82.6108 1129.29L-82.6108 1227.26C-82.6108 1243.75 -69.2467 1257.11 -52.7612 1257.11H375.849C392.335 1257.11 405.699 1243.75 405.699 1227.26V1099.44H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.4765 1099.44C-74.0441 1099.44 -82.6108 1108.01 -82.6108 1118.58C-82.6108 1129.14 -74.0441 1137.71 -63.4764 1137.71H228.897C245.383 1137.71 258.747 1124.35 258.747 1107.86V1099.44H-63.4765Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7612 1099.44C-69.2467 1099.44 -82.6108 1086.08 -82.6108 1069.59V1006.83C-82.6108 990.345 -69.2467 976.981 -52.7612 976.981H262.574C279.059 976.981 292.423 990.345 292.423 1006.83V1099.44H-52.7612Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.425 1099.44V1089.49C292.425 1073.01 305.789 1059.64 322.274 1059.64H405.7V1099.44H292.425Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 976.98V968.56C143.941 952.075 157.305 938.711 173.791 938.711H258.748V976.98H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.974 938.712L524.331 938.712C540.817 938.712 554.181 952.076 554.181 968.561L554.181 1059.64L518.974 1059.64L518.974 938.712Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 298.497,
    height: 261.759,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 29.8981 1098.68)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 384.219,
    height: 73.4761,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 1012.96)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 99.4988,
    height: 150.014,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 914.982)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 61.2301,
    height: 410.241,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 914.982)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 938.712L143.941 1282.37C143.941 1298.85 157.305 1312.21 173.791 1312.21H337.581C354.067 1312.21 367.431 1298.85 367.431 1282.37V938.712H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 938.712V1290.02C554.183 1306.5 540.819 1319.87 524.333 1319.87H397.281C380.795 1319.87 367.431 1306.5 367.431 1290.02V938.712H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.333 880.543C540.819 880.543 554.183 893.908 554.183 910.393V1059.64H397.281C380.795 1059.64 367.431 1046.28 367.431 1029.79V910.393C367.431 893.908 380.795 880.543 397.281 880.543H524.333Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725.627,
    y: 1059.64,
    width: 122.46,
    height: 205.121,
    rx: 29.8497,
    transform: "rotate(90 725.627 1059.64)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 261.759,
    height: 411.772,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 106.437 836.917)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 382.688,
    height: 407.18,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 257.981 836.917)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2374_65786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.699 277.372V10.2556C405.699 -6.22986 419.063 -19.594 435.549 -19.594H636.077C652.563 -19.594 665.927 -6.22983 665.927 10.2557V277.372H405.699Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.251 277.372V210.784C632.251 194.299 645.615 180.935 662.101 180.935H686.593C703.078 180.935 716.442 194.299 716.442 210.784V277.372H632.251Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 141.13V151.08C554.183 167.566 567.547 180.93 584.032 180.93H686.593C703.078 180.93 716.442 167.566 716.442 151.08V141.13H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.906 -19.5975L440.906 -11.1784C440.906 5.30711 454.27 18.6712 470.755 18.6712L554.181 18.6713L554.181 -19.5975L440.906 -19.5975Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.6106,
    y: 63.0662,
    width: 296.966,
    height: 260.228,
    rx: 29.8497,
    transform: "rotate(-90 -82.6106 63.0662)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.6106,
    y: 101.332,
    width: 241.859,
    height: 523.517,
    rx: 29.8497,
    transform: "rotate(-90 -82.6106 101.332)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.761 101.332C-69.2465 101.332 -82.6106 87.968 -82.6106 71.4825L-82.6106 -110.677C-82.6106 -127.162 -69.2465 -140.527 -52.7609 -140.527L375.85 -140.527C392.335 -140.527 405.699 -127.162 405.699 -110.677V101.332L-52.761 101.332Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.761 101.332C-69.2465 101.332 -82.6106 87.968 -82.6106 71.4825L-82.6106 -26.4856C-82.6106 -42.9711 -69.2465 -56.3353 -52.7609 -56.3353L375.85 -56.3353C392.335 -56.3353 405.699 -42.9711 405.699 -26.4856V101.332L-52.761 101.332Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.4762 101.332C-74.0439 101.332 -82.6106 92.7654 -82.6106 82.1978C-82.6106 71.6301 -74.0438 63.0634 -63.4762 63.0634L228.897 63.0634C245.383 63.0634 258.747 76.4275 258.747 92.913V101.332L-63.4762 101.332Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7609 101.332C-69.2464 101.332 -82.6106 114.696 -82.6106 131.182V193.942C-82.6106 210.428 -69.2465 223.792 -52.7609 223.792H262.574C279.059 223.792 292.424 210.428 292.424 193.942V101.332L-52.7609 101.332Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.425 101.332V111.282C292.425 127.767 305.789 141.132 322.274 141.132H405.7V101.332H292.425Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 223.794V232.213C143.941 248.698 157.306 262.063 173.791 262.063H258.748V223.794H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.974 262.061L524.331 262.061C540.817 262.061 554.181 248.697 554.181 232.212L554.181 141.132L518.974 141.132L518.974 262.061Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6636,
    y: 101.332,
    width: 298.497,
    height: 261.759,
    rx: 29.8497,
    transform: "rotate(-90 30.6636 101.332)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 187.051,
    width: 384.219,
    height: 73.4761,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 187.051)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 285.027,
    width: 99.4988,
    height: 150.014,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 285.027)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.8115,
    y: 285.027,
    width: 61.2301,
    height: 410.241,
    rx: 29.8497,
    transform: "rotate(-90 -42.8115 285.027)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 262.061L143.941 -81.5924C143.941 -98.0779 157.306 -111.442 173.791 -111.442H337.581C354.067 -111.442 367.431 -98.0779 367.431 -81.5924V262.061H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 262.061V-89.2462C554.183 -105.732 540.819 -119.096 524.333 -119.096H397.281C380.795 -119.096 367.431 -105.732 367.431 -89.2462V262.061H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.333 320.231C540.819 320.231 554.183 306.867 554.183 290.382V141.133H397.281C380.795 141.133 367.431 154.497 367.431 170.983V290.382C367.431 306.867 380.795 320.231 397.281 320.231H524.333Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.765376,
    y: -0.765376,
    width: 122.46,
    height: 205.121,
    rx: 29.8497,
    transform: "matrix(0 -1 -1 0 724.862 140.366)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.203,
    y: 363.09,
    width: 261.759,
    height: 411.772,
    rx: 29.8497,
    transform: "rotate(-90 107.203 363.09)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.747,
    y: 363.09,
    width: 382.688,
    height: 407.18,
    rx: 29.8497,
    transform: "rotate(-90 258.747 363.09)",
    stroke: "#363746",
    strokeWidth: 1.53075
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2374_65786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.699 246.583V513.699C405.699 530.185 419.063 543.549 435.549 543.549H636.077C652.563 543.549 665.927 530.185 665.927 513.699V246.583L405.699 246.583Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.251 246.583V313.171C632.251 329.656 645.615 343.021 662.101 343.021H686.593C703.078 343.021 716.442 329.656 716.442 313.171V246.583H632.251Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 382.823V372.873C554.183 356.388 567.547 343.023 584.032 343.023H686.593C703.078 343.023 716.442 356.388 716.442 372.873V382.823H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.906 543.554L440.906 535.135C440.906 518.649 454.27 505.285 470.755 505.285L554.181 505.285L554.181 543.554L440.906 543.554Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 296.966,
    height: 260.228,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -83.376 460.125)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 241.859,
    height: 523.517,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -83.376 421.858)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.761 422.623C-69.2465 422.623 -82.6106 435.987 -82.6106 452.473L-82.6106 634.632C-82.6106 651.118 -69.2465 664.482 -52.7609 664.482H375.85C392.335 664.482 405.699 651.118 405.699 634.632V422.623L-52.761 422.623Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.761 422.623C-69.2465 422.623 -82.6106 435.987 -82.6106 452.473L-82.6106 550.441C-82.6106 566.926 -69.2465 580.29 -52.7609 580.29H375.85C392.335 580.29 405.699 566.926 405.699 550.441V422.623L-52.761 422.623Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.4762 422.623C-74.0439 422.623 -82.6106 431.19 -82.6106 441.757C-82.6106 452.325 -74.0438 460.892 -63.4762 460.892H228.897C245.383 460.892 258.747 447.528 258.747 431.042V422.623H-63.4762Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7609 422.622C-69.2464 422.622 -82.6106 409.258 -82.6106 392.772V330.011C-82.6106 313.526 -69.2465 300.162 -52.7609 300.162H262.574C279.059 300.162 292.424 313.526 292.424 330.011V422.622H-52.7609Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.425 422.622V412.672C292.425 396.186 305.789 382.822 322.274 382.822H405.7V422.622H292.425Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 300.16V291.741C143.941 275.255 157.306 261.891 173.791 261.891H258.748V300.16H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.617 580.29V573.402C177.617 556.916 190.981 543.552 207.467 543.552H292.424V580.29H177.617Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.974 261.892L524.331 261.892C540.817 261.892 554.181 275.256 554.181 291.742L554.181 382.821L518.974 382.821L518.974 261.892Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 298.497,
    height: 261.759,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 29.8982 421.858)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 384.219,
    height: 73.4761,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 336.138)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 99.4988,
    height: 150.014,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 238.163)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 61.2301,
    height: 410.241,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 -43.5769 238.163)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.941 261.892L143.941 605.546C143.941 622.031 157.306 635.395 173.791 635.395H337.581C354.067 635.395 367.431 622.031 367.431 605.546V261.892H143.941Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.183 261.892V613.199C554.183 629.685 540.819 643.049 524.333 643.049H397.281C380.795 643.049 367.431 629.685 367.431 613.199V261.892H554.183Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.333 203.724C540.819 203.724 554.183 217.088 554.183 233.574V382.822H397.281C380.795 382.822 367.431 369.458 367.431 352.972V233.573C367.431 217.088 380.795 203.724 397.281 203.724H524.333Z",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725.627,
    y: 382.823,
    width: 122.46,
    height: 205.121,
    rx: 29.8497,
    transform: "rotate(90 725.627 382.823)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 261.759,
    height: 411.772,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 106.437 160.098)",
    stroke: "#363746",
    strokeWidth: 1.53075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.765376,
    y: 0.765376,
    width: 382.688,
    height: 407.18,
    rx: 29.8497,
    transform: "matrix(0 1 1 0 257.981 160.098)",
    stroke: "#363746",
    strokeWidth: 1.53075
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 67.9995,
    cy: -6.00243,
    r: 157.5,
    transform: "rotate(180 67.9995 -6.00243)",
    stroke: "url(#paint1_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    transform: "matrix(-1 0 0 1 625 976)",
    stroke: "url(#paint2_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "matrix(-1 0 0 1 272 174)",
    stroke: "url(#paint3_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 1126,
    r: 103.5,
    stroke: "url(#paint4_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.375 63H215.687C215.906 61.6562 216.5 60.1875 217.5 58.5937C219.5 55.4375 223.531 52.3437 227 51.625V50.3125C225.281 49.9375 223.594 49.1562 221.969 48C218.656 45.6562 216.219 42.1562 215.687 39H214.375C214.062 40.6562 213.344 42.25 212.219 43.875C210 47.0937 206.531 49.4687 203 50.3125V51.625C204.781 52 206.594 52.875 208.375 54.2188C212 56.9375 213.906 60.3125 214.375 63Z",
    fill: "url(#paint5_linear_2374_65786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.062 1095H498.031C498.359 1092.98 499.25 1090.78 500.75 1088.39C503.75 1083.66 509.797 1079.02 515 1077.94V1075.97C512.422 1075.41 509.891 1074.23 507.453 1072.5C502.484 1068.98 498.828 1063.73 498.031 1059H496.062C495.594 1061.48 494.516 1063.87 492.828 1066.31C489.5 1071.14 484.297 1074.7 479 1075.97V1077.94C481.672 1078.5 484.391 1079.81 487.062 1081.83C492.5 1085.91 495.359 1090.97 496.062 1095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.062 1095H498.031C498.359 1092.98 499.25 1090.78 500.75 1088.39C503.75 1083.66 509.797 1079.02 515 1077.94V1075.97C512.422 1075.41 509.891 1074.23 507.453 1072.5C502.484 1068.98 498.828 1063.73 498.031 1059H496.062C495.594 1061.48 494.516 1063.87 492.828 1066.31C489.5 1071.14 484.297 1074.7 479 1075.97V1077.94C481.672 1078.5 484.391 1079.81 487.062 1081.83C492.5 1085.91 495.359 1090.97 496.062 1095Z",
    fill: "url(#paint6_linear_2374_65786)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6.5,
    width: 719,
    height: 1105,
    stroke: "#615971"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2374_65786",
    x: 0,
    y: 0,
    width: 740,
    height: 1126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2374_65786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2374_65786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2374_65786",
    x1: 370,
    y1: 6,
    x2: 370,
    y2: 1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2374_65786",
    x1: 67.9995,
    y1: -164.002,
    x2: 67.9995,
    y2: 151.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597111,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2374_65786",
    x1: 23,
    y1: 0,
    x2: 23,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597111,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2374_65786",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597111,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2374_65786",
    x1: 675,
    y1: 1022,
    x2: 675,
    y2: 1230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597111,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2374_65786",
    x1: 215,
    y1: 39,
    x2: 215,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "#262839"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2374_65786",
    x1: 497,
    y1: 1059,
    x2: 497,
    y2: 1095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "#262839"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2374_65786"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 720,
    height: 1106,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2374_65786"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.99976,
    y: 939.647,
    width: 339.827,
    height: 742.801,
    rx: 18.369,
    transform: "rotate(-90 9.99976 939.647)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2374_65786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 339.827,
    height: 742.801,
    rx: 18.369,
    transform: "matrix(0 1 1 0 9.99976 937.947)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2374_65786"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.99988,
    y: 262.827,
    width: 339.827,
    height: 742.801,
    rx: 18.369,
    transform: "rotate(-90 9.99988 262.827)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2374_65786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 339.827,
    height: 742.801,
    rx: 18.369,
    transform: "matrix(0 1 1 0 9.99988 261.127)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bgLogin.cb1fec01697b7056ae3f6b3aaf3a5004.svg";
export { ForwardRef as ReactComponent };